"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Step_1 = __importDefault(require("../Step"));
const VardaService_1 = __importDefault(require("../../services/VardaService"));
const service = new VardaService_1.default();
class VardaStepModel extends Step_1.default {
    constructor(config) {
        super(config.id);
        this.data = config.data;
    }
    resetStep() {
        this.data.fields = [];
        this.data.selectedFields = [];
    }
    resetSelectFields() {
        this.data.selectedFields = [];
    }
    async getVardaFields(url) {
        await service.getFields(url);
        service.fields.forEach(field => {
            this.data.fields.push(field);
        });
    }
    get validFields() {
        return this.data.selectedFields.filter((f) => f.closeToFarm);
    }
    addSelectedFields(field) {
        this.data.selectedFields.push(field);
    }
    setFarmNameToAllFields(farm) {
        this.data.selectedFields.forEach((f) => f.farmName = farm);
    }
    setCropToAllFields(crop) {
        this.data.selectedFields.forEach((f) => f.crop = crop);
    }
}
exports.default = VardaStepModel;
